import { render, staticRenderFns } from "./MainLoading.vue?vue&type=template&id=8ab60a6a"
import script from "./MainLoading.vue?vue&type=script&lang=js"
export * from "./MainLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports